//console.log('js loaded');

//Import
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Flip} from "gsap/Flip";
import {Scroll} from "./Scroll";
import {SplitText} from "gsap/SplitText";


gsap.registerPlugin(ScrollTrigger,Flip,SplitText);

//gsap.to('.home__hero-wrap',{opacity:1,duration:.5})


let spT2 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineChild" });
let spT1 = new SplitText(".home__hero-title", { type: "lines", linesClass: "lineParent" });

gsap.set(spT1.lines,{overflow:"hidden"});
gsap.set(spT2.lines,{scale:.5,opacity:0});
gsap.set('.header',{ opacity: 0,scale:0.5 })

var intl = gsap.timeline();

intl
    .add('start')
    .to(spT2.lines,{
        scale:1,
        opacity:1,
        duration: 1.5,
        ease: "power2.inOut",
        stagger: {
            each: 0.1,
            from: "end"
        }
    },'start')
    .to('.header',{
        scale:1,
        opacity:1,
        duration: 1.5,
        ease: "power2.inOut",
        stagger: {
            each: 0.1
        }
    },'start')



setTimeout(()=>{

    if (document.querySelectorAll('.stagger-in').length > 0) {

        document.querySelectorAll('.stagger-in').forEach(el=>{


            let elements = el.querySelectorAll('.stagger-in__el')


            gsap.from(elements, {
                opacity: 0,
                duration: .8,
                yPercent:50,
                stagger: {
                    each: 0.1
                },
                scrollTrigger: {
                    trigger: el,
                    markers: false,
                    start: "top 75%",
                }
            });

        });
    }


    Scroll.scrollTo(0, {
        immediate:true,
    })



    let elements = document.querySelectorAll('.element');

    elements.forEach((el,i)=>{
        const elementState = Flip.getState(el);

        document.querySelector(el.dataset.target).append(el);

        Flip.from(elementState, {
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });

        gsap.to(el, {
            opacity: 1,
            duration: 1.5,
            delay: i*0.2,
            ease: "power1.inOut",
        });

    });

},250);


import Swiper,  { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

// init Swiper:
const swiper = new Swiper('.swiper', {
      slidesPerView: 1.2,
      //centeredSlides: true,
      spaceBetween: 15,
      //freeMode: true,
      loop:true,
    cssMode:true,
     autoplay: {
       delay: 2500,
     },

      breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 15,
        },
      },
    }
);


const swiper2 = new Swiper('.swiper.recensioni', {
      slidesPerView: 1.2,
      //centeredSlides: true,
      spaceBetween: 15,
      //freeMode: true,
      loop:true,
    cssMode:true,

      breakpoints: {
        640: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 15,
        },
      },
    }
);




